import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import EmployerSignupPanel from '../Registration/EmployerSignupPanel';
import './RegistrationModal.scss';

function RegistrationModal({
  showModal,
  hideModal,
  csrfToken,
  googleOmniauthUrl,
  msOmniauthUrl,
  signInUrl,
  extraParams,
  header,
  showTestimonials,
  location,
  inviterId,
  projectResourceId,
}) {
  return (
    <Modal
      show={showModal}
      onHide={hideModal}
      dialogClassName="style-guide registration-modal"
    >
      <Modal.Header closeButton />
      <Modal.Body>
        <EmployerSignupPanel
          csrfToken={csrfToken}
          googleOmniauthUrl={googleOmniauthUrl}
          msOmniauthUrl={msOmniauthUrl}
          signInUrl={signInUrl}
          showReferralPanel={false}
          {...(header && { header })}
          {...(Object.keys(extraParams).length && { extraParams })}
          showTestimonials={showTestimonials}
          location={location}
          inviterId={inviterId}
          projectResourceId={projectResourceId}
        />
      </Modal.Body>
    </Modal>
  );
}

RegistrationModal.propTypes = {
  showModal: PropTypes.bool,
  hideModal: PropTypes.func,
  csrfToken: PropTypes.string.isRequired,
  googleOmniauthUrl: PropTypes.string.isRequired,
  msOmniauthUrl: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
  extraParams: PropTypes.shape({}),
  header: PropTypes.string,
  showTestimonials: PropTypes.bool,
  location: PropTypes.string.isRequired,
  inviterId: PropTypes.string,
  projectResourceId: PropTypes.string,
  requestCallbackChosen: PropTypes.bool,
};

RegistrationModal.defaultProps = {
  showModal: false,
  hideModal: () => {},
  requestCallbackChosen: false,
  extraParams: {},
  header: null,
  showTestimonials: false,
  inviterId: null,
  projectResourceId: null,
};

export default RegistrationModal;
